export const SESSION_STORAGE_COUNTRY_CODE = 'country_code';
export const SESSION_STORAGE_PURCHASE_APROVED = 'purchaseApproved';
export const SESSION_STORAGE_BLOG_CATEGORY_ID = 'selectedCategoryId';
